import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(protected authService: AuthenticationService, protected router: Router) { }

  ngOnInit() {
    const promise = this.authService.signout();
    promise.then(() => this.router.navigate(['/login']));
  }

}



// WEBPACK FOOTER //
// ./src/app/logout/logout.component.ts